import { render } from "./SwitchCategoryType.vue?vue&type=template&id=25fed1ce&scoped=true&ts=true"
import script from "./SwitchCategoryType.vue?vue&type=script&lang=ts"
export * from "./SwitchCategoryType.vue?vue&type=script&lang=ts"

import "./SwitchCategoryType.vue?vue&type=style&index=0&id=25fed1ce&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fed1ce"]])

export default __exports__